import * as React from "react";
import styled from "styled-components";
import { InView } from "react-intersection-observer";
// components
import IconTouchArea from "common/components/iconTouchArea";
import MediaLazyTransitionWrapper from "common/components/mediaWrapper";
import Icon, { PACKS } from "common/icons";

const GifWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;
const BlockResourceWrapper = styled(InView)`
  position: relative;
  width: 100%;
  height: 100%;
  margin: auto;

  img {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    margin: auto;
  }
`;

interface IProps {
  block: Vingle.IAnimatedImage;
}

interface IState {
  isPlaying: boolean;
  isError: boolean;
}

class GifPlayer extends React.PureComponent<IProps, IState> {
  public state = {
    isPlaying: false,
    isError: false,
  };
  private refVideoElement = React.createRef<HTMLVideoElement>();

  public render() {
    const { isPlaying } = this.state;
    const { block } = this.props;
    const source =
      block.sources.find(
        sourceCandidate => sourceCandidate.type === "video/mp4",
      ) || block.sources[0];

    let gifMark: React.ReactNode | null = null;
    if (!isPlaying) {
      gifMark = (
        <IconTouchArea onClick={this.handlePlayGif}>
          <Icon className="gifIcon" icon={PACKS.MEDIA.GIF} />
        </IconTouchArea>
      );
    }

    return (
      <BlockResourceWrapper onChange={this.handleVisibilityChange}>
        {gifMark}
        <GifWrapper>
          <MediaLazyTransitionWrapper
            type="video"
            src={source.src}
            width={block.width}
            height={block.height}
            previewColor={block["preview-color"]}
            blurHash={block.blur_hash}
          >
            <video
              poster={block.poster}
              ref={this.refVideoElement}
              src={source.src}
              playsInline={true}
              autoPlay={true}
              loop={true}
              muted={true}
              onError={this.handleGifLoadError}
              onPlay={this.handlePlayState}
              onPause={this.handlePlayState}
              onLoadedData={this.handlePlayGif}
            >
              <source src={source.src} type="video/mp4" />
            </video>
          </MediaLazyTransitionWrapper>
        </GifWrapper>
      </BlockResourceWrapper>
    );
  }

  private readonly handleVisibilityChange = async (isVisible: boolean) => {
    try {
      if (isVisible) {
        await this.playVideo();
      } else {
        await this.pauseVideo();
      }
    } catch {
      // tslint:disable-next-line:no-empty
    }
  };

  private readonly playVideo = async () => {
    const videoElement = this.refVideoElement.current;
    if (videoElement && videoElement.paused) {
      const playPromise = videoElement.play();
      if (playPromise) {
        await playPromise;
      }
    }
  };

  private readonly pauseVideo = async () => {
    const videoElement = this.refVideoElement.current;
    if (videoElement && !videoElement.paused) {
      const playPromise = videoElement.play();
      if (playPromise) {
        await playPromise;
      }
      videoElement.pause();
    }
  };

  private readonly handlePlayState: React.ReactEventHandler = e => {
    this.setState({
      isPlaying: e.type === "play",
    });
  };

  private readonly handlePlayGif = () => {
    this.playVideo();
  };

  private readonly handleGifLoadError = () => {
    this.setState({
      isError: true,
    });
  };
}

export default GifPlayer;
